export default {
  api: {
    pay: {
      method: "post",
      url: "/balance/pay"
    },
    balanceStatus: {
      method: "get",
      url: "/balance/status/{orderNo}"
    },
    balance: {
      method: "get",
      url: "/balance/info"
    },
    list: {
      method: "get",
      url: "/user/order/list"
    },
    statistics: {
      method: "get",
      url: "/home/statistics"
    },
    apply: {
      method: "post",
      url: "/balance/withdrawal/apply"
    },
    list1: {
      method: "get",
      url: "/balance/withdrawal/list"
    }
  }
};
